import SendSuggestionBadge from '@/assets/img/scorecard/task_badges/send-suggestion.svg'
import LoginBadge from '@/assets/img/scorecard/task_badges/login.svg'
import DailyCheckInBadge from '@/assets/img/scorecard/task_badges/daily-check-in.svg'

export interface TaskInfo {
    expires: number, // Countdown in seconds from this number e.g. 3600 = 1 hour
    achievements: AchievementDetails[]
}

export interface AchievementDetails {
    type: TaskAchievement,
    title: string,
    description ?: string
    rules: string
    completed: number,
    total: number
}

type TaskAchievement = "login" | "checkin" | "suggestion"

export const AchievementBadges = {
    login: LoginBadge,
    checkin: DailyCheckInBadge,
    suggestion: SendSuggestionBadge
}
